import React from 'react';
import { css } from 'styled-components';
export var screenReaderOnly = css(["position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0;"]);
export var body = css(["font-size:", ";line-height:", ";"], function (p) {
  return p.theme.fonts.body.fontSize;
}, function (p) {
  return p.theme.fonts.body.lineHeight;
});
export var bodySmall = css(["font-size:", ";line-height:", ";"], function (p) {
  return p.theme.fonts.small.fontSize;
}, function (p) {
  return p.theme.fonts.small.lineHeight;
});
export var title = css(["font-weight:bold;font-size:", ";line-height:", ";color:", ";"], function (p) {
  return p.theme.fonts.body.fontSize;
}, function (p) {
  return p.theme.fonts.body.lineHeight;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.textPrimary;
});
export var subtitle = css(["font-weight:bold;font-size:", ";line-height:", ";"], function (p) {
  return p.theme.fonts.small.fontSize;
}, function (p) {
  return p.theme.fonts.small.lineHeight;
});
export var caption = css(["font-size:", ";line-height:", ";"], function (p) {
  return p.theme.fonts.caption.fontSize;
}, function (p) {
  return p.theme.fonts.caption.lineHeight;
});
export var tagline = css(["font-weight:bold;font-size:", ";line-height:", ";"], function (p) {
  return p.theme.fonts.caption.fontSize;
}, function (p) {
  return p.theme.fonts.caption.lineHeight;
});
export var fontSmoothing = css(["-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;"]);
export var buttonReset = css(["box-sizing:border-box;appearance:none;border:none;background-color:transparent;font-size:100%;font-family:inherit;text-decoration:none;text-transform:none;cursor:pointer;"]);
export default (function () {
  return /*#__PURE__*/React.createElement(React.Fragment, null);
});